module.exports = __webpack_public_path__ + "img/plus_btn.0c00c9d8.png";